var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_16",
    "data-name": "Union 16",
    d: "M-309.707,19.708-318,11.414l-8.293,8.293A1,1,0,0,1-327,20a1,1,0,0,1-.707-.293,1,1,0,0,1,0-1.415L-319.414,10l-8.293-8.293a1,1,0,0,1,0-1.415,1,1,0,0,1,1.414,0L-318,8.586l8.293-8.293a1,1,0,0,1,1.414,0,1,1,0,0,1,0,1.415L-316.586,10l8.293,8.293a1,1,0,0,1,0,1.415A1,1,0,0,1-309,20,1,1,0,0,1-309.707,19.708Z",
    transform: "translate(328 0)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/crossIcon.9c3acbc22508c24f4286d4e9cdf8f606.svg";
export { ForwardRef as ReactComponent };